<template>
  <div class="format">
    <div class="renew3_wrapper format_wrapper">
      <div
        v-for="block in blocks"
        :key="block.key"
        class="format_block"
        :class="block.block_class"
      >
        <h3
          v-if="block.heading"
          class="format_block_h3"
          :class="block.heading_class"
        >
          {{ block.heading }}
        </h3>
        <p v-if="block.lead" class="format_block_lead">
          {{ block.lead }}
        </p>

        <div class="flex format_block_flex">
          <a
            v-for="(card, index) in block.cards"
            :key="card.id || `${block.key}-${index}`"
            :href="card.href"
            :id="card.id || undefined"
            class="format_link"
          >
            <div class="format_link_top" :class="card.top_class">
              <p v-if="card.memo" class="format_link_memo">{{ card.memo }}</p>
              <img
                :src="card.img_src"
                :alt="card.img_alt"
                class="format_link_img"
              />
            </div>
            <div class="format_link_bottom" :class="card.bottom_class">
              <h3 class="format_link_h3" :class="card.title_class">
                {{ card.title }}
              </h3>
              <p v-if="card.subtitle" class="format_link_txt">
                {{ card.subtitle }}
              </p>
            </div>
            <button class="format_btn" :class="card.btn_class">
              {{ card.btn_label }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import formatBlocksJson from '@/assets/top/top-new-format-blocks.json'

type FormatCard = {
  href: string
  id: string
  memo: string
  img_src: string
  img_alt: string
  top_class: string
  bottom_class: string
  title: string
  title_class: string
  subtitle: string
  btn_class: string
  btn_label: string
}

type FormatBlock = {
  key: string
  block_class: string
  heading: string
  heading_class: string
  lead: string
  cards: FormatCard[]
}

const blocks = (formatBlocksJson as { blocks: FormatBlock[] }).blocks
</script>
